import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import ProductCustomizationHeader from "@/features/cake-customization/ProductCustomizationHeader";
import ActionButton from "@/components/ActionButton";
import Counter from "@/features/cake-customization/Counter";
import { getStateFromPincode } from "@/utils/pincode";
import ContactSection from "@/components/ContactSection";
import { useEarliestDelivery } from "@/hooks/useEarliestDelivery";
import ProductAccordion from "@/components/ProductAccordion";
import { Truck, ShoppingBag } from "lucide-react";
interface ProductHeaderProps {
  product: {
    vendor_details?: {
      pin_code?: string;
    };
    in_stock?: boolean;
    customization_info?: unknown[];
    category_name?: string;
    [key: string]: unknown;
  };
  currentPrice: number;
  dietaryCategories: Record<string, unknown>[];
  formData: {
    count: number;
    [key: string]: unknown;
  };
  onIncrement: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDecrement: (e: React.MouseEvent<HTMLButtonElement>) => void;
  vendorId: string | number | null;
  prepTimeHours?: number;
  onAddToCart: () => void;
  onBuyNow: () => void;
  handleCustomizedNameChange?: (name: string) => void;
}
const ProductHeader: React.FC<ProductHeaderProps> = t0 => {
  const $ = _c(50);
  const {
    product,
    currentPrice,
    dietaryCategories,
    formData,
    onIncrement,
    onDecrement,
    vendorId,
    prepTimeHours: t1,
    onAddToCart,
    onBuyNow,
    handleCustomizedNameChange
  } = t0;
  const prepTimeHours = t1 === undefined ? 0 : t1;
  const pincode = product?.vendor_details?.pin_code;
  let t2;
  let t3;
  if ($[0] !== pincode) {
    t2 = ["shippingState", pincode];
    t3 = async () => {
      const result = await getStateFromPincode(pincode);
      return result ?? null;
    };
    $[0] = pincode;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = !!pincode;
  let t5;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: Infinity
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    data: shippingState
  } = useQuery(t5);
  const isOutOfStock = !product?.in_stock;
  useEarliestDelivery(vendorId ? Number(vendorId) : undefined, null, prepTimeHours);
  const t6 = product?.vendor_details?.business_name || "";
  const t7 = `/${product?.vendor_details?.slug}/${product?.vendor_details?.id}`;
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = {
      _id: "",
      name: t6,
      link: t7
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = product?.name;
  let t10;
  if ($[10] !== currentPrice) {
    t10 = currentPrice.toFixed(2);
    $[10] = currentPrice;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = parseFloat(t10);
  let t12;
  if ($[12] !== t11) {
    t12 = t11.toString();
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = product?.vendor_details?.free_shipping_threshold;
  let t14;
  if ($[14] !== dietaryCategories || $[15] !== formData || $[16] !== onDecrement || $[17] !== onIncrement || $[18] !== prepTimeHours || $[19] !== product || $[20] !== shippingState || $[21] !== t12 || $[22] !== t13 || $[23] !== t8 || $[24] !== t9 || $[25] !== vendorId) {
    t14 = <ProductCustomizationHeader baker={t8} title={t9} price={t12} labels={dietaryCategories} vendorId={vendorId} prepTimeHours={prepTimeHours} formData={formData} onIncrement={onIncrement} onDecrement={onDecrement} shippingState={shippingState} freeShippingThreshold={t13} product={product} />;
    $[14] = dietaryCategories;
    $[15] = formData;
    $[16] = onDecrement;
    $[17] = onIncrement;
    $[18] = prepTimeHours;
    $[19] = product;
    $[20] = shippingState;
    $[21] = t12;
    $[22] = t13;
    $[23] = t8;
    $[24] = t9;
    $[25] = vendorId;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== formData || $[28] !== isOutOfStock || $[29] !== onAddToCart || $[30] !== onBuyNow || $[31] !== onDecrement || $[32] !== onIncrement || $[33] !== product?.customization_info?.length) {
    t15 = <div className="hidden lg:flex flex-col space-y-6 w-full pt-8 pb-4">{isOutOfStock ? <div className="py-2 bg-[#FFE5E5] w-full font-outfit text-[#B91C1C] text-center text-xl font-medium rounded-md">Out of Stock</div> : <><div className="flex gap-6 w-full items-center"><Counter count={formData.count} maxCount={10} onIncrement={onIncrement} onDecrement={onDecrement} variant="outlined" classNames="!border-[#bdc9c5] !text-gray-800 px-6 py-3 h-14 w-auto flex justify-between bg-white select-none lg:text-lg text-lg font-bold !rounded-xl" buttonClassNames="hover:text-[#037A6A] transition-colors" /><ActionButton variant="solid" onClick={onAddToCart} className="flex-1 h-14 flex items-center justify-center gap-3 bg-gradient-to-r from-[#037A6A] to-[#049480] text-white !font-extrabold hover:scale-[1.02] active:scale-95 shadow-lg hover:shadow-[#037A6A]/20 tracking-wider text-xl !rounded-xl"><ShoppingBag className="w-5 h-5" />ADD TO CART</ActionButton></div>{product?.customization_info?.length > 0 && <div className="py-1 bg-[#FDF4FF] w-full font-outfit text-[#8A226F] text-center text-xl rounded-md">Available for Customization</div>}<ActionButton variant="outlined" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onBuyNow();
        }} className="w-full h-14 flex items-center justify-center bg-white hover:bg-[#037A6A]/5 active:scale-95 tracking-wider text-xl !rounded-xl !font-extrabold">BUY NOW</ActionButton></>}</div>;
    $[27] = formData;
    $[28] = isOutOfStock;
    $[29] = onAddToCart;
    $[30] = onBuyNow;
    $[31] = onDecrement;
    $[32] = onIncrement;
    $[33] = product?.customization_info?.length;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== formData || $[36] !== handleCustomizedNameChange || $[37] !== isOutOfStock || $[38] !== onAddToCart || $[39] !== onBuyNow || $[40] !== onDecrement || $[41] !== onIncrement || $[42] !== product || $[43] !== shippingState) {
    t16 = isOutOfStock ? <div className="py-1 bg-[#FFE5E5] w-full font-outfit text-[#B91C1C] text-center text-xl font-medium lg:hidden">Out of Stock</div> : <><div className="flex flex-col sm:flex-row items-center gap-4 w-full lg:hidden max-lg:my-4 sm:gap-3">{!isOutOfStock && <Counter count={formData.count} maxCount={10} onIncrement={onIncrement} onDecrement={onDecrement} strokeWidth={3} countClassNames="font-extrabold" classNames="sm:h-[56px] lg:px-6 px-4 max-sm:hidden sm:text-2xl text-base w-auto " buttonClassNames="sm:w-10 sm:h-10 sm:bg-[#037A6A]/10 sm:hover:bg-[#037A6A]/20 text-[#037A6A] rounded-full flex items-center justify-center transition-all" />}{product?.metadata?.show_customized_name && !isOutOfStock && <div className="w-full sm:hidden space-y-2"><input type="text" value={formData.customizedName as string || ""} onChange={e_0 => handleCustomizedNameChange?.(e_0.target.value)} placeholder="Enter name to customize..." className="w-full outline-none px-3 py-2 appearance-none border-[1px] rounded-md placeholder:text-sm text-sm border-[#D9D9D9]" maxLength={100} /></div>}<div className="grid grid-cols-2 gap-3 w-full sm:flex-1"><ActionButton text="Buy Now" variant="outlined" onClick={e_1 => {
            e_1.preventDefault();
            e_1.stopPropagation();
            onBuyNow();
          }} className="w-full text-xl font-semibold rounded-xl whitespace-nowrap px-0 border border-[#037A6A] text-[#037A6A] hover:bg-[#037A6A]/5" /><ActionButton text="Add to Cart" variant="solid" onClick={onAddToCart} className="w-full rounded-xl text-xl font-semibold whitespace-nowrap px-0 bg-gradient-to-r from-[#037A6A] to-[#049480] shadow-[0_4px_12px_rgba(3,122,106,0.3)] hover:-translate-y-0.5 transition-transform" /></div></div>{product?.customization_info?.length > 0 && !isOutOfStock && <div className="px-3"><div className="py-1 bg-[#FDF4FF] w-full font-outfit text-[#8A226F] text-center lg:text-xl text-base lg:hidden ">Available for Customization</div></div>}<div className="lg:hidden"><ProductAccordion product={product} /></div><div className="mt-8 lg:mt-3 mb-8 w-full"><div className="bg-v2-surface-container-low p-5 rounded-xl flex items-center justify-center gap-3"><Truck className="text-v2-primary w-5 h-5 shrink-0 opacity-70" /><p className="text-stone-500 font-medium text-xs leading-relaxed text-center">Usually delivered within 4–8 days. Check your exact delivery date at checkout.</p></div></div>{(shippingState || product?.vendor_details?.free_shipping_threshold) && <div className="md:hidden w-full bg-[#F9F8F6] px-4 py-4 mb-8"><div className="flex flex-col space-y-3 font-outfit w-fit mx-auto items-start">{product?.vendor_details?.free_shipping_threshold && product?.vendor_details?.free_shipping_threshold > 0 && <div className="flex items-center gap-1.5 text-[13px]"><span className="text-[#303030] font-semibold tracking-wider uppercase">FREE SHIPPING:</span><span className="text-[#5A5A5A]">Above ₹{parseFloat(product?.vendor_details?.free_shipping_threshold.toString()).toString()}</span></div>}{shippingState && <div className="flex items-center gap-1.5 text-[13px]"><span className="text-[#303030] font-semibold tracking-wider uppercase">SHIPS FROM:</span><span className="text-[#5A5A5A]">{shippingState}</span></div>}</div></div>}</>;
    $[35] = formData;
    $[36] = handleCustomizedNameChange;
    $[37] = isOutOfStock;
    $[38] = onAddToCart;
    $[39] = onBuyNow;
    $[40] = onDecrement;
    $[41] = onIncrement;
    $[42] = product;
    $[43] = shippingState;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="lg:hidden block w-full"><ContactSection /></div>;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t14 || $[47] !== t15 || $[48] !== t16) {
    t18 = <>{t14}{t15}{t16}{t17}</>;
    $[46] = t14;
    $[47] = t15;
    $[48] = t16;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  return t18;
};
export default ProductHeader;